import { ROOT_GLOBAL } from "../global/root";
import { LocalStorage } from "./LocalStorage";

export class Auth {
  constructor(id, full_name, refresh_token, auth_token) {
    this.id = id;
    this.fullName = full_name;
    this.refreshToken = refresh_token;
    this.authToken = auth_token;
  }
  static fromApiObject(input) {
    if (input && typeof(input) === "object") {
      return new Auth(input.id, input.full_name, input.refresh_token, input.auth_token)
    }
    return new Auth();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Auth.fromApiObject(item));
    }
    if (typeof(input) === "object") {
      return [Auth.fromApiObject(input)];
    }
    return [];
  }

  isVaildAuth() {
    return !!this.authToken && !!(this.id + '')
  }

  saveLoginInfo(useOldRefresh = false) {
    LocalStorage.setLoginInfo(this.authToken, this.fullName, this.id, useOldRefresh ? LocalStorage.getRefreshToken() : this.refreshToken);
  }

  setNewToken() {
    LocalStorage.setUserToken(this.authToken);
  }

  static callBackLogin(cb) {
    if (cb === undefined) {
      cb = window.location.href;
    }
    return `${ROOT_GLOBAL.LOGIN}&cb=${encodeURIComponent(cb)}`
  }

  static callBackSignUp(cb) {
    if (cb === undefined) {
      cb = window.location.href;
    }
    return `${ROOT_GLOBAL.SIGN_UP}&cb=${encodeURIComponent(cb)}`
  }
}